import { render, staticRenderFns } from "./getOrder.vue?vue&type=template&id=53b168c1&scoped=true"
import script from "./getOrder.vue?vue&type=script&lang=js"
export * from "./getOrder.vue?vue&type=script&lang=js"
import style0 from "./getOrder.vue?vue&type=style&index=0&id=53b168c1&prod&scoped=true&lang=css"
import style1 from "./getOrder.vue?vue&type=style&index=1&id=53b168c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b168c1",
  null
  
)

export default component.exports